import { gqlSystemRoleCode } from '@minecraft.graphql-types';

/**
 * @deprecated use PermissionsProvider instead
 * ability.can('request-approval', 'role') for isPC
 */
export function isPC(systemRole: gqlSystemRoleCode): boolean {
  return systemRole === gqlSystemRoleCode.PROJECT_CREATOR;
}

/**
 * @deprecated use PermissionsProvider instead
 * ability.can('publish', 'role') for isCD / isStudio
 */
export function isCD(systemRole: gqlSystemRoleCode): boolean {
  return systemRole === gqlSystemRoleCode.CASTING_DIRECTOR;
}

export function isStudio(systemRole: gqlSystemRoleCode): boolean {
  return systemRole === gqlSystemRoleCode.STUDIO;
}

export function isCollaborator(systemRole: gqlSystemRoleCode): boolean {
  return systemRole === gqlSystemRoleCode.SHARED_PROJECT_USER;
}
